import styled from 'styled-components'

const ContentDiv = styled.div`
	width: 500px;
	display: flex;
	flex-direction: column;
	gap: 30px;
	padding: 20px 0;
`

const FormDiv = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
`

const Row = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`

const GradeBox = styled.div`
	width: 200px;
	height: 50px;
	border: 1px solid #c2c2c2;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding-left: 15px;
	font-size: 14px;
	color: #333;
`

const PriceInput = styled.input`
	flex: 1;
	height: 50px;
	border: 1px solid #c2c2c2;
	border-radius: 5px;
	padding: 0 15px;
	font-size: 14px;

	&::placeholder {
		color: #c2c2c2;
	}
`

const BtnDiv = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 10px;
	width: 150px;
	margin: 0 auto;
`

const Style = {
	ContentDiv,
	FormDiv,
	Row,
	GradeBox,
	PriceInput,
	BtnDiv,
}

export default Style
